import React, { useRef } from "react";
import Accordion from "../Accordion/Accordion";
import InfoSection from "../InfoSection/InfoSection";
import styles from "./VisitUsContent.module.scss";

const VisitUsContent = ({ sections, sectionIds }) => {
  const ref = useRef();
  const useIsomorphicLayoutEffect = typeof window !== 'undefined' ? React.useLayoutEffect : React.useEffect;
  useIsomorphicLayoutEffect(() => {
    if (window.location && window.location.search) {
      const pathName = window.location.pathname
      const id = window.location.search.replace('?q=', '');

      if(id) {
        //let ci = setInterval(() => {
          const elemToScroll = document.getElementById(id);

          if(!elemToScroll) return;

          // Rimozione query param
          window.history.pushState({}, document.title, '' + pathName);

          setTimeout(() => {
            // scroll to
            window.scrollTo({
              top: elemToScroll.offsetTop -120,
              behavior: 'smooth'
            }); 
          }, 120)          

        //  clearInterval(ci);
        //}, 250);
      }
    }
  }, [ref.current]);

  return (
    <div className={styles.visitUs} ref={ref}>
      {sections && sections.map((d, i) => (
        d.accordion ?
          (
            <div id={sectionIds[i]} key={'accordion-container-' + i} className={"anchor_section"}>
              <Accordion key={'visit-us-accordion-' + i} title={d.title} items={d.infos} fullscreen={false} />
            </div>   
          ) :
          (
            <div id={sectionIds[i]} key={'infosection-container-' + i} className={"anchor_section " + styles.infoSection}>
              <InfoSection key={'visit-us-info-' + i} {...d} />
            </div>
          )
      ))}
    </div>
  );
};

export default VisitUsContent;
